import {ApolloClient} from '@apollo/client';
import {useCallback, useEffect, useSyncExternalStore} from 'react';
import {toast} from 'sonner';
import {
  bulkCloseRunner,
  BulkCloseStartInput,
  getCounts,
} from './bulkCloseRunner';

export const useBulkCloseRun = () =>
  useSyncExternalStore(bulkCloseRunner.subscribe, bulkCloseRunner.getSnapshot);

export const useBulkCloseStatus = () => {
  const run = useBulkCloseRun();
  const counts = getCounts(run);

  return {
    counts,
    jobInFlight: !!run && !counts.isComplete,
    run,
  };
};

export const useBulkCloseActions = () => {
  const start = useCallback(
    (input: BulkCloseStartInput) => bulkCloseRunner.start(input),
    [],
  );
  const dismiss = useCallback(() => bulkCloseRunner.dismiss(), []);

  return {dismiss, start};
};

export const useConfigureBulkClose = (
  client: ApolloClient<object>,
  onComplete: () => void,
) => {
  useEffect(() => {
    bulkCloseRunner.setClient(client);
    bulkCloseRunner.setOnComplete(onComplete);
    bulkCloseRunner.setOnError(message => toast.error(message));
    bulkCloseRunner.resumeFromStorage();
  }, [client, onComplete]);
};
